import { Builder } from '@builder.io/react'
import React from 'react'
import './discount.css'

interface Object {
  image: any
  imageAltText: string
  messageText: string
}

interface Props {
  backgroundColor: string
  items: Object[]
}

const RunningLineMulti = ({ backgroundColor, items }: Props) => {
  // Create large array for continuous carousel
  let duplicatedItems: any = []
  for (let i = 0; i < 10; i++) {
    duplicatedItems = duplicatedItems.concat(items)
  }

  return (
    <div className="w-full mx-auto" style={{ backgroundColor: backgroundColor }}>
      <div className="scroller" data-animated="true">
        <ul className="tag-list scroller__inner multi_scroll">
          {duplicatedItems.map((item: any, i: number) => (
            <li key={`${i}`} className="flex flex-row">
              <img
                className="w-6 h-6 lg:w-12 lg:h-16"
                src={item.image}
                style={{
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center'
                }}
                // alt={item.imageAltText}
                alt=""
              />
              <div className="ml-3 flex items-center w-full ">
                <p className="text-xs lg:text-base" dangerouslySetInnerHTML={{ __html: item.messageText }}></p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
export default RunningLineMulti

Builder.registerComponent(RunningLineMulti, {
  name: 'RunningLineMulti',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'items',
      type: 'list',
      subFields: [
        { name: 'image', type: 'file', defaultValue: null },
        { name: 'imageAltText', type: 'string', defaultValue: '' },
        { name: 'messageText', type: 'richText', defaultValue: '' }
      ]
    }
  ]
})
